module.exports={render:function (){with(this) {
  return _h('div', {
    attrs: {
      "id": "Chatbot"
    }
  }, [_h('transition', {
    attrs: {
      "name": "helloTrans"
    }
  }, [_h('hello', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (helloIsOpen),
      expression: "helloIsOpen"
    }],
    attrs: {
      "bot-name": this.botName
    }
  })]), " ", _h('transition', {
    attrs: {
      "name": "chatwindowTrans"
    }
  }, [(chatIsOpen) ? _h('chat-window', {
    attrs: {
      "bot-name": this.botName
    }
  }) : _e()])])
}},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-1d503b40!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chatbot/Chatbot.vue
 ** module id = 26
 ** module chunks = 1
 **/